import { render, staticRenderFns } from "./SalesSummary.vue?vue&type=template&id=67c1703c&scoped=true&"
import script from "./SalesSummary.vue?vue&type=script&lang=ts&"
export * from "./SalesSummary.vue?vue&type=script&lang=ts&"
import style0 from "./SalesSummary.vue?vue&type=style&index=0&id=67c1703c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c1703c",
  null
  
)

export default component.exports